// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3oKWg","footer":"ChangeClinic_footer__1Qkry"};